import React from 'react';
import { renderFromComponentMap } from '@cmpsr/contentful-core/lib/renderers';
import { DisclosureLink } from '../../../contentModels/DisclosureLink';
import { ComponentRendererWithQuery } from '@goodrx/x-core';
/**
 * Query section content by id and render it inside DisclosureLink Drawer
 * @param attrs
 */

export const getDrawerContentById = attrs => {
  const disclosureLinkProps = {
    displayTitle: attrs.text,
    copy: /*#__PURE__*/React.createElement(ComponentRendererWithQuery, {
      context: {
        restLink: true
      },
      variables: {
        id: attrs.entryId
      },
      type: "Section"
    })
  };
  const componentMapLocal = {
    default: () => /*#__PURE__*/React.createElement(DisclosureLink, disclosureLinkProps)
  };
  return renderFromComponentMap(componentMapLocal, 'default');
};